<div class="vertical-line"></div>
<div class=" reservation_step ">
  <ul>
    <li routerLinkActive="active " class="left-link ">

      <span>1.</span> Personal
    </li>
    <li routerLinkActive=" active ">

      <span>2.</span> Conference
    </li>
    <li routerLinkActive="active " class="active">

      <span>3.</span> Accommodation
    </li>
    <li routerLinkActive="active ">

      <span>4.</span> Room Choice
    </li>
    <li routerLinkActive="active ">

      <span>5.</span> Tour
    </li>
    <li routerLinkActive="active " class="right-link ">

      <span>6.</span> Confirm
    </li>
  </ul>
</div>


<div class="info">
  <form class="row" [formGroup]="accomodationinfoForm" class="personalinfo" (submit)="submitAccommodationInfo()">
    <div class="form-group">
      <div class="row">
        <label>Arrival Date:</label>
        <kendo-datepicker style="width: 500px;" [min]="arrivalMinDate" formControlName="arrivalDate"></kendo-datepicker>
      </div>
      <div class="row">
        <label>Departure Date:</label>
        <kendo-datepicker style="width: 500px;" [min]="departureMinDate" formControlName="departureDate"></kendo-datepicker>
      </div>

      <div class="row">
        <label>Choose Lunch(Day 1):</label>

        <kendo-dropdownlist style="width: 500px;" [data]="mealList" formControlName="meal1">
          <ng-template kendoComboBoxItemTemplate let-dataItem>
            <span>{{dataItem}} - ${{mealsObject[dataItem]}}</span>
          </ng-template>
        </kendo-dropdownlist>

      </div>

      <div class="row">
        <label>Choose Lunch(Day 2):</label>
        <kendo-dropdownlist style="width: 500px;" [data]="mealList" formControlName="meal2">
          <ng-template kendoComboBoxItemTemplate let-dataItem>
            <span>{{dataItem}} - ${{mealsObject[dataItem]}}</span>
          </ng-template>
        </kendo-dropdownlist>
      </div>


      <div class="row">
        <label>Choose Lunch(Day 3):</label>
        <kendo-dropdownlist style="width: 500px;" [data]="mealList" formControlName="meal3">
          <ng-template kendoComboBoxItemTemplate let-dataItem>
            <span>{{dataItem}} - ${{mealsObject[dataItem]}}</span>
          </ng-template>
        </kendo-dropdownlist>
      </div>
      <div class="row">
        <label>Other Info:</label>
        <textarea formControlName="otherInfo" style="width: 500px;" class="textarea-field" rows="5"></textarea>
      </div>

      <div class="form-buttons">
        <button class="btn btn-success" (click)="cancel()">Cancel</button>
        <button class="btn btn-success" type="submit">Next</button>
      </div>
    </div>
  </form>
</div>


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/form-components/accomodationinfo/accomodationinfo.component.html